<!-- HEADER -->
<header class="page-header" id="trigger">

  <!-- topbar -->
  <div class="topbar d-none d-md-block">
    <div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
      <div class="d-flex flex-row flex-wrap align-items-center justify-content-end">

        <app-user-menu
          [user]="user"
          [salesRep]="salesRep"
          [admin]="admin"
          [languages]="languages"
          *ngIf="!isSimplified"
          (onSelectCustomer)="selectCustomer()"
          ></app-user-menu>

      </div>
    </div>
  </div>

  <!-- logo search and cart -->
  <div class="wrapper">

    <div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">

      <div class="d-flex flex-wrap align-items-center row">

        <div class="page-header_mobilemenu d-block d-md-none col-sm-4 col">
          <!-- menu -->
          <button class="navbar-toggler" (click)="toggleNavbar()" *ngIf="navigateUrl !== '/checkout'">
            <i class="fa fa-bars"></i>
          </button>
        </div>

        <div class="page-header_logo col-lg-3 col-md-3 col-sm-4 col-3">
          <a routerLink="/" class="logo-tenant-as-background"></a>
        </div>

        <div class="page-header_search d-none d-md-block col-lg-5 offset-lg-0 col-md-5 offset-md-1 col-sm-12 col-6">
          <app-search-bar
            class="navbar-form navbar-right"
            *ngIf="loggedIn && !(salesRep && !customerSelected) && !isSimplified"
            [searchTerm]="searchTerm"
            [onNavigation]="onNavigation"
            (onSearch)="doSearch($event)">
          </app-search-bar>
        </div>

        <div
          class="page-header_cart col-lg-4 col-md-3 col-sm-4 col text-right"
          *ngIf="loggedIn && !(salesRep && !customerSelected)">

          <a class="btn btn-success" [ngClass]="cart?.productCount ? '' : 'cart-empty'" [routerLink]="cart?.productCount ? ['/checkout'] : []" id="cartbutton" >
            <span class="cart-icon">
              <i class="fa fa-shopping-cart"></i>
              <span class="badge badge-pill badge-success">
                {{cart?.productCount}}
              </span>
            </span>
            <span class="cart-value" *ngIf="cart?.value">
                {{(cart?.value ? cart?.value : 0) | price: currency }}
            </span>
          </a>

        </div>

      </div>
    </div>
  </div>
</header>

<app-navbar
  *ngIf="!isSimplified"
  [menuItems]="menuItems"
  [user]="user"
  [salesRep]="salesRep"
  [ngClass]="{'show-mobile-menu': showMobileMenu, 'show-mobile-user-options': showMobileUserOptions }"
  [languages]="languages"
  [topMenuStyle]="topMenuStyle"
  (onToggleNavBar)="toggleNavbar()"
  (onToggleMobileUserOptions)="toggleMobileUserOptions()"
  (onSelectCustomer)="selectCustomer()"
  (onItemClick)="itemClick()"
  ></app-navbar>

  <div class="navbar-mobile-overlay d-block d-md-none" [ngClass]="{'active': showMobileMenu}"></div>
